import {createApp} from 'vue'
import StafetDeltagSomFighterStepOne from './StafetDeltagSomFighterStepOne'

const el = '.kb-component--stafet-deltag-som-fighter-step-one'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((StafetDeltagSomFighterStepOneDOM)=>{
            const component = createApp(StafetDeltagSomFighterStepOne).use(Store)
            component.mount(StafetDeltagSomFighterStepOneDOM)
        })
    }
}